export default __webpack_public_path__ + "static/media/menu.d39fb409.svg";